














































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import tinycolor from "tinycolor2";
import { GaHelper } from "@/core/helpers/ga";
import { isAfter } from "date-fns";

@Component
export default class App extends Vue {
    @Prop() widgetid: number;
    maxWidthPx = "830px";

    async created() {
        this.$store.direct.commit.setAppLoading(true);
        (this.$root as any).br = this.$vuetify.breakpoint; // can't assign by definition, but actually can
        let widgetId = this.getWidgetId();
        console.log("widgetId=" + widgetId);
        await this.$store.direct.dispatch.loadWidget(widgetId);
        GaHelper.Init(this.widget.id.toString());
        GaHelper.send("view");
        this.updateColor();
        this.updateMaxWidth();
        (this.br as any).update(); // update method is hidden from Breakpoint interface

        const params = this.parseHash();
        console.log("parseHash", params);
        if (!!params?.cardId) {
            await this.$store.direct.dispatch.insurance.init(params.cardId);
            try {
                await this.$store.direct.dispatch.iccalc.initCurrentCalc({
                    icname: params.icname,
                    cardId: params.cardId
                });
            } catch (e) {
                console.error(e);
                this.$router.push({ name: "precheck" });
                return;
            }
            await this.$store.direct.dispatch.iccalc.getCalcs(params.cardId);
            // to get expirationDate we need to load calcs first
            let expirationDate = this.$store.direct.state.iccalc.calcStates
                .find(
                    x =>
                        x.insuranceProviderId ==
                        this.$store.direct.state.iccalc.currentCalc
                            ?.insuranceProviderId
                )
                ?.expirationDate?.parseDate?.();
            console.log("dates", expirationDate, new Date());
            let isPaylinkValid = expirationDate
                ? isAfter(expirationDate, new Date())
                : false;

            if (params.action != "checkData" && isPaylinkValid) {
                this.$store.direct.commit.insurance.setPaylinkUsed();
                this.$router.push({ name: "finish" });
            } else {
                //go to 4 step
                this.$router.push({
                    name: "initStepper",
                    params: { step: "4" }
                });
                this.$store.state.showRecentCalc = false;
            }
        } else {
            this.$router.push({ name: "welcome" });
            this.$store.direct.dispatch.insurance.init(null);
        }

        this.initOtpBank();
        this.watchSettings();
        this.$store.direct.commit.setAppLoading(false);
    }
    async mounted() {
        // ie 11 fix ♿ и танцы с линтером ♿
        const parts = [
            `<script src="https://`,
            `cdn.jsdelivr.net/gh/nuxodin/ie11Cust`,
            `omProperties@4.1.0/ie11Custom`,
            `Properties.min.js"><\/script>`
        ];
        window.MSInputMethodContext &&
            (document as any).documentMode &&
            document.write(parts.join());
    }
    initOtpBank() {
        const inputEl = document.getElementById("otp") as HTMLInputElement;
        if (!inputEl) return;
        const json = decodeURIComponent(inputEl.value).replaceAll("+", " ");
        if (json) {
            console.log("setting data from OTP", JSON.parse(json));
            this.$store.direct.commit.insurance.setOtpBankData(
                JSON.parse(json).tokenData
            );
        }
    }
    getWidgetId() {
        let widgetId = null;
        let inputEl = document.getElementById("widgetId") as HTMLInputElement;
        if (inputEl?.value) return inputEl.value;
        // window.location.hash should be #5 or #5&whatever, i.e. id should come first
        let hash = window.location.hash.replace("#", "").split("&")[0].split("?")[0];
        if (hash?.length == 36) widgetId = hash;
        else widgetId = "00000000-0000-0000-0000-000000000000";
        return widgetId;
    }
    parseHash(): { cardId: string; action: string; icname: string } {
        let hashItems = { cardId: "", action: "", icname: "" };
        let hash = window.location.hash
        if (window.location.hash.includes("?")) hash = window.location.hash.split("?")[0];
        let items = hash.replace("#", "").split("&");
        const _widgetArgument = items.shift(); // get rid of id
        items.forEach(x => {
            const name = x.split("=", 1)[0];
            hashItems[name] = x.replace(name + "=", "");
        });
        return hashItems;
    }
    updateColor() {
        let primary = "#7245ff";
        let color = this.widget.color;
        const buttonsShadowStyle = this.widget?.buttonsShadowStyle;
        const validationColor = this.widget?.validationColor;
        if (/^#([0-9A-F]{3}){1,2}$/i.test(color)) primary = color; // f13370-pink, 12efbf- light green "#7245ff"-original
        let root = document.documentElement;
        if (buttonsShadowStyle)
            root.style.setProperty("--ppdw-primary-button-shadow", buttonsShadowStyle);
        if (validationColor)
            root.style.setProperty("--ppdw-validation-color", validationColor);

        // generate shades of primary colors to use with app
        const darker1Shade = tinycolor(primary)
            .desaturate(26)
            .darken(16)
            .toString();
        const lighter1Shade = tinycolor(primary)
            .lighten(22.8)
            .toString();
        const lighter2Shade = tinycolor(primary)
            .lighten(32.5)
            .toString();
        const lightestShade = tinycolor(primary)
            .lighten(35)
            .toString();
        // set css variables with our colors
        root.style.setProperty("--ppdw-primary", primary);
        root.style.setProperty("--ppdw-darker-1", darker1Shade);
        root.style.setProperty("--ppdw-lighter-1", lighter1Shade);
        root.style.setProperty("--ppdw-lighter-2", lighter2Shade);
        root.style.setProperty("--ppdw-lightest", lightestShade);
        // replace vuetify theme colors with freshly generated ones
        let newTheme = { ...this.$vuetify.theme };
        newTheme.themes.light = {
            primary,
            secondary: darker1Shade,
            accent: lighter1Shade,
            error: "#b71c1c",
            info: "#0f0c0f",
            warning: "#0d0f0f",
            success: "#0d0303"
        };
        this.$vuetify.theme = { ...newTheme };
        let isDefaultColor = primary.toUpperCase() == "#7245FF";
        if (isDefaultColor) primary = "#5381FE"; // override border color
        root.style.setProperty("--ppdw-border", primary);
    }
    updateMaxWidth() {
        const width = this.widget.width;
        if (width.endsWith("px") && width.slice(0, -2) <= "830")
            this.maxWidthPx = width;
    }
    watchSettings() {
        window.addEventListener(
            "message",
            event => {
                const isCorrectParent =
                    event.origin.endsWith("pampadu.ru") ||
                    event.origin.startsWith("http://localhost:808");
                const isCorrectCall =
                    typeof event.data === "object" &&
                    event.data.call === "sendSettings";
                if (isCorrectParent && isCorrectCall) {
                    this.updateSettings(event.data.value);
                }
            },
            false
        );
        window.parent.postMessage("ready", "*");
    }
    updateSettings({
        color,
        title,
        subtitle,
        titleOn,
        subtitleOn,
        borderOn
    }: {
        color: string;
        title: string;
        subtitle: string;
        titleOn: boolean;
        subtitleOn: boolean;
        borderOn: boolean;
    }) {
        this.widget.titleOn = titleOn;
        this.widget.subtitleOn = subtitleOn;
        this.widget.borderOn = borderOn;
        this.widget.title = title;
        this.widget.subtitle = subtitle;
        if (this.widget.color.toUpperCase() != color.toUpperCase()) {
            this.widget.color = color;
            this.updateColor();
        }
    }
    get br() {
        return this.$vuetify.breakpoint;
    }
    get widget() {
        return this.$store.direct.state.widget;
    }
    get subtitle() {
        if (!["b2c", "b2ctest"].includes(process.env.VUE_APP_ENV))
            return this.widget.subtitle + ` [name: ${this.br.name}]`;
        else return this.widget.subtitle;
    }
    get headerVisible() {
        const headerExists = this.widget.title || this.widget.subtitle;
        if (this.br.mdAndUp) return headerExists;
        return headerExists && this.$route.name == "welcome";
    }
}
